// ============================================================
// Mock Users
// ============================================================

import { ROLES } from '@/constants/roles';

export const mockUsers = [
  {
    id: 'user-super-admin',
    name: 'SaaS Super Admin',
    email: 'superadmin@erp.com',
    password: '1234',
    role: ROLES.SUPER_ADMIN,
    schoolId: null, // Super Admin has no specific school
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-owner',
    name: 'System Owner',
    email: 'owner@greenvalley.edu',
    password: '1234', // Simulated password
    role: ROLES.ORGANIZATION_ADMIN,
    schoolId: null, // Owner can access all schools
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-principal',
    name: 'Dr. Sarah Johnson',
    email: 'principal@greenvalley.edu',
    password: '1234',
    role: ROLES.PRINCIPAL,
    schoolId: 'school-1', // Assigned to Green Valley
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-reception',
    name: 'Lisa Martinez',
    email: 'reception@greenvalley.edu',
    password: '1234',
    role: ROLES.RECEPTION,
    schoolId: 'school-1', // Assigned to Green Valley
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-accountant',
    name: 'David Wilson',
    email: 'accountant@greenvalley.edu',
    password: '1234',
    role: ROLES.ACCOUNTANT,
    schoolId: 'school-1', // Assigned to Green Valley
    avatar: null,
    status: 'active',
  },
  // ── Teacher Users ──────────────────────────────────────────
  {
    id: 'user-teacher-1',
    name: 'Rajesh Sharma',
    email: 'rajesh.sharma@greenvalley.edu',
    password: '1234',
    role: ROLES.TEACHER,
    schoolId: 'school-1',
    teacherId: 'teacher-1',
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-teacher-2',
    name: 'Priya Patel',
    email: 'priya.patel@greenvalley.edu',
    password: '1234',
    role: ROLES.TEACHER,
    schoolId: 'school-1',
    teacherId: 'teacher-2',
    avatar: null,
    status: 'active',
  },
  {
    id: 'user-teacher-3',
    name: 'Amit Kumar',
    email: 'amit.kumar@greenvalley.edu',
    password: '1234',
    role: ROLES.TEACHER,
    schoolId: 'school-1',
    teacherId: 'teacher-3',
    avatar: null,
    status: 'active',
  },
];
